// Bun needs static imports to collapse the importmap controller graph into one development asset.
import { application } from "controllers/application"
import CategoryMenuController from "controllers/category_menu_controller"
import ClipboardController from "controllers/clipboard_controller"
import DialogController from "controllers/dialog_controller"
import FormValidationController from "controllers/form_validation_controller"
import GalleryController from "controllers/gallery_controller"
import ListingFormController from "controllers/listing_form_controller"
import ListingPhotoPreloadController from "controllers/listing_photo_preload_controller"
import LocalityAutocompleteController from "controllers/locality_autocomplete_controller"
import MobileNavigationController from "controllers/mobile_navigation_controller"
import PaymentRequestController from "controllers/payment_request_controller"
import PriceHintController from "controllers/price_hint_controller"
import ProfileController from "controllers/profile_controller"
import SaleFormController from "controllers/sale_form_controller"
import ShareController from "controllers/share_controller"
import TurnstileController from "controllers/turnstile_controller"
import WatchdogConditionsController from "controllers/watchdog_conditions_controller"

application.register("category-menu", CategoryMenuController)
application.register("clipboard", ClipboardController)
application.register("dialog", DialogController)
application.register("form-validation", FormValidationController)
application.register("gallery", GalleryController)
application.register("listing-form", ListingFormController)
application.register("listing-photo-preload", ListingPhotoPreloadController)
application.register("locality-autocomplete", LocalityAutocompleteController)
application.register("mobile-navigation", MobileNavigationController)
application.register("payment-request", PaymentRequestController)
application.register("price-hint", PriceHintController)
application.register("profile", ProfileController)
application.register("sale-form", SaleFormController)
application.register("share", ShareController)
application.register("turnstile", TurnstileController)
application.register("watchdog-conditions", WatchdogConditionsController)
